module.exports = __webpack_public_path__ + "img/3.3277d574.png";